const Accordion = () => ({
  activeBlockId: null,
  getHeightStyle() {
    const id = this.$el.dataset.blockId;
    const header = this.$el.querySelector("button");
    const headerHeight = header.clientHeight;

    const content = this.$el.querySelector("div");
    const contentHeight = content.clientHeight;

    const collapsedHeight = headerHeight + "px";
    const expandedHeight = headerHeight + contentHeight + "px";

    return `height: ${this.activeBlockId === id ? expandedHeight : collapsedHeight}`;
  },
  toggleBlock(id) {
    this.activeBlockId = this.activeBlockId === id ? "" : id;
  },
  init() {
    // Trigger a re-run of getHeightStyle to account for content changes while styles are applied
    setTimeout(() => {
      this.activeBlockId = "";
    }, 50);
  },
});

export default Accordion;
